<template>
  <div class="home">
    <BodyPractical />
  </div>
</template>

<script>
// @ is an alias to /src
import BodyPractical from "@/components/BodyPractical.vue";

export default {
  name: "Home",
  components: {
    BodyPractical,
  },
};
</script>

